import { WrapperVersion } from '../../shared/models/wrapper-version.model';
import { PwaConfigService } from '../services/pwa-config.service';

export function pwaWrapperVersionFactory(pwaConfigService: PwaConfigService): WrapperVersion {
    return pwaConfigService.config.mock ? pwaConfigService.config.mock.wrapperVersion : Windows.ApplicationModel.Package.current.id.version;
}
